import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    context: 'post_payment_info',
    path: 'patient.id',
    viewPath: props.viewPath,
  })

  return {
    variables: { patient_id },
  }
}
